import { render, staticRenderFns } from "./list-tenants-for-user-group.vue?vue&type=template&id=5a394d8e&scoped=true&"
import script from "./list-tenants-for-user-group.vue?vue&type=script&lang=tsx&"
export * from "./list-tenants-for-user-group.vue?vue&type=script&lang=tsx&"
import style0 from "./list-tenants-for-user-group.vue?vue&type=style&index=0&id=5a394d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a394d8e",
  null
  
)

export default component.exports